import { useEffect, useState, useContext } from "react";
import styles from "../CreateUser/CreateUserModal.module.css";
import {FaChevronDown, FaEye, FaEyeSlash} from "react-icons/fa";
import {formatPhone} from "../../../utils/PhoneUtils";
import {formatCPF} from "../../../utils/FormatUtils";
import {getStoresFromDatabase} from "../../../hooks/Store";
import {insertUser} from "../../../hooks/User";
import {UserContext} from '../../../context/UserContext';
import {GetStoreIds} from '../../../utils/GetStoreIds';
import { AuthContext } from '../../../context/AuthContext';

function Modal({ closeModal }) {
  const { addUser } = useContext(UserContext);
  const { user } = useContext(AuthContext);
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [phone, setPhone] = useState("");
  const [access, setAccess] = useState("");
  const [stores, setStores] = useState([]);
  const [storeIds, setStoreIds] = useState([]);
  const [selectedStores, setSelectedStores] = useState([]);
  const [isUserRoleDropdownOpen, setIsUserRoleDropdownOpen] = useState(false);
  const [isStoreDropdownOpen, setIsStoreDropdownOpen] = useState(false);
  const [selectedUserRole, setSelectedUserRole] = useState("Selecione a função do usuário");
  const [selectedStore, setSelectedStore] = useState("Selecione a loja");
  
  const toggleUserRoleDropdown = () => { setIsUserRoleDropdownOpen(!isUserRoleDropdownOpen) };
  const toggleStoreDropdown = () => { setIsStoreDropdownOpen(!isStoreDropdownOpen) };
  const handleUserRoleSelect = ( role ) => {
    setSelectedUserRole(role);
    switch ( role ) {
      case "Master/Admin":
        setRole("MASTER")
        setAccess("PANEL_ADMIN_ACCESS")
        break;
      case "Gerente":
        setRole("MANAGER")
        setAccess("PANEL_ADMIN_ACCESS")
        break;
      case "Usuário de App":
        setRole("APP_USER")
        setAccess("APP_ACCESS")
        break;
      case "Usuário de Painel":
        setRole("PANEL_USER")
        setAccess("PANEL_ACCESS")
        break;
      default:
        setRole("")
        break;
    }
  };

  const handleToggleStoreSelection = ( store ) => {
    setSelectedStores(( prevSelectedStores ) => {
      if (prevSelectedStores.some((s) => s.id === store.id)) {
        return prevSelectedStores.filter((s) => s.id !== store.id);
      } else {
        return [...prevSelectedStores, store];
      }
    });
  };
  
  const handleSelectStore = ( store ) => {
    setSelectedStore(store.name);
    setStoreIds([store.id])
  };

  useEffect(() => {
    const fetchStores = async () => {
      const storeData = await getStoresFromDatabase();
      if (storeData) {
        setStores(storeData.data.stores);
      }
    };
    fetchStores();
  },[]);

  useEffect(() => {
    setStoreIds(GetStoreIds(selectedStores));
}, [ selectedStores ]);

  const handlePhoneChange = (e) => {
    const rawValue = e.target.value;
    const formattedPhone = formatPhone(rawValue);
    setPhone(formattedPhone);
  };

  const handleSaveUser = async () => {
    const userData = { 
      name, 
      username: username.replace(/\D/g, ''),
      password, 
      phone, 
      role, 
      access, 
      storeIds
  };
    const response = await insertUser( userData );
    if (response) {
      addUser(true)
      closeModal();
    } else {
      addUser(false)
    }
  };

  const renderStoresDropdown = () => {
    if(role === "MANAGER") {
      return (
        <>
          <button 
          type="button" 
          onClick={ toggleStoreDropdown } 
          className={styles.dropdownButton}>Selecione uma ou mais lojas<FaChevronDown className={styles.icon} />  </button>  
        </>
      )
    }else {
      return (
        <>
          <button 
          type="button" 
          onClick={ toggleStoreDropdown } 
          className={styles.dropdownButton}> { selectedStore } <FaChevronDown className={styles.icon} />  </button>  
        </>
      )
    }
  }
  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <form>
            <label>
              <span>Nome</span>
              <input
                type="text"
                required
                placeholder="Digite o nome do usuário"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </label>

            <label>
              <span>CPF</span>
              <input
                type="text"
                required
                placeholder="Digite o CPF do usuário"
                value={ username }
                onChange={(e) => setUsername(formatCPF(e.target.value))}
              />
            </label>

            <label>
              <span>Senha</span>
              <div className={styles.passwordFieldWrapper}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  required
                  placeholder="Digite a senha do usuário"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className={styles.passwordToggleButton}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </label>

            <label>
              <span>Telefone</span>
              <input
                type="text"
                required
                placeholder="Digite o telefone do usuário"
                value={phone}
                onChange={ handlePhoneChange }
              />
            </label>

            <label>
              <span>Função do Usuário</span>
              <div className={styles.dropdown}>
                <button type="button" onClick={ toggleUserRoleDropdown } className={styles.dropdownButton}>
                  {selectedUserRole} <FaChevronDown className={styles.icon} />
                </button>
                { isUserRoleDropdownOpen && (
                  <div className={styles.dropdownContent}>
                    {user?.role === 'MASTER' && (
                      <div onClick={() => handleUserRoleSelect("Master/Admin")}>Master/Admin</div>
                    )}
                    {user?.role === 'MASTER' && (
                      <div onClick={() => handleUserRoleSelect("Gerente")}>Gerente</div>
                    )}
                    <div onClick={() => handleUserRoleSelect("Usuário de App")}>Usuário de App</div>
                    <div onClick={() => handleUserRoleSelect("Usuário de Painel")}>Usuário de Painel</div>
                  </div>
                )}
              </div>
            </label>

            <label>
              <span>Loja</span>
                <div className={styles.dropdown}>
                { renderStoresDropdown() }
                { isStoreDropdownOpen && role !== "MANAGER" ? (
                  <div className={styles.dropdownContent}>
                    {stores.map((store) => (
                      <div key={store.id} onClick={() => handleSelectStore( store )}>
                        {store.name}
                      </div>
                    ))}
                  </div>
                ): null}
                { isStoreDropdownOpen && role === "MANAGER" ? (
                  <div className={styles.dropdownContent}>
                        {stores.map((store) => (
                          <div key={store.id} className={styles.storeItem}>
                            <div className={styles.checkboxLabel}>
                              <input 
                                  type="checkbox"
                                  checked={ selectedStores.some((s) => s.id === store.id)}
                                  onChange={() => handleToggleStoreSelection(store)}
                                />
                            </div>
                              
                            <span>{store.name}</span>
                          </div>
                        ))}
                    </div>

                  ) : null } 
              </div>
            </label>
          </form>
        </div>
        <div className={styles.buttonContent}>
          <button className={styles.buttonConfirm} onClick={ handleSaveUser }>Salvar Usuário</button>
          <button onClick={closeModal} className={styles.buttonCancel}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
